var render = function render(){var _vm=this,_c=_vm._self._c;return _c('DefaultContent',{attrs:{"image":'empty-resources.png',"title":'No Wallets Found',"subtitle":'Click the button below to get started'}},[_c('ActivateWalletButton')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }